<template>
  <v-app>
    <Appbar />
    <NavigationDrawer />
    <v-main v-touch="{ up: () => swipe('Up'), down: () => swipe('Down')}">
      <Loader :show="loader" />
      <v-container fluid>
        <vue-page-transition name="fade-in-down">
          <router-view :class="{'max-1000': $vuetify.breakpoint.lgAndDown}" />
        </vue-page-transition>
      </v-container>
    </v-main>
    <v-expand-transition>
      <Footer v-if="swipeDirection === 'Down'" />
    </v-expand-transition>
    <Cookiebanner />
    <Snackbar />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Appbar from '@components/appbar';
import NavigationDrawer from '@components/navigation_drawer';
import Loader from '@components/loader';
import Footer from '@components/footer';
import Snackbar from '@components/snackbar';
import Cookiebanner from '@components/cookiebanner';
import availableLanguages from '@/config/languages';
import loaderMethods from '@/mixins/loader';

export default {
  name: 'App',
  components: {
    Appbar,
    NavigationDrawer,
    Loader,
    Footer,
    Snackbar,
    Cookiebanner,
  },
  mixins: [loaderMethods],
  data: () => ({
    availableLanguages,
    swipeDirection: 'Down',
  }),
  computed: {
    ...mapGetters('user', ['appLanguage']),
    ...mapGetters('current', ['loader']),
  },
  methods: {
    ...mapActions('current', ['setFooterVisibility']),

    initAppLanguage() {
      if (this.appLanguage) {
        this.$i18n.locale = this.appLanguage;
      } else {
        const browserLanguage = (window.navigator.userLanguage || window.navigator.language).slice(0, 2);
        this.$i18n.locale = availableLanguages.includes(browserLanguage) ? browserLanguage : 'en';
      }
    },
    swipe (direction) {
      this.swipeDirection = direction;
      this.setFooterVisibility(direction === 'Down');
    },
  },
  created() {
    this.initAppLanguage();
    this.setFooterVisibility(true);
    // reset loader if wrongly state has been stored accidentally
    this.hideLoader(0);
  },
};
</script>

<style lang="scss">
.max-1000 {
  max-width: 1000px;
  margin: 0 auto;
}
</style>
